import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ApiError } from '@/lib/api'

type LoadErrorProps = { error: unknown; className?: string; children?: ReactNode }

/** Torneo o partita che non si caricano: 404 → "non trovato" (link vecchio, torneo eliminato), 409 `drawInProgress`
 * → estrazione live in corso (squadre e partite non sono ancora pubbliche), altrimenti errore generico (rete). */
export function LoadError({ error, className, children }: LoadErrorProps) {
  const { t } = useTranslation()
  const isNotFound = error instanceof ApiError && error.status === 404
  const isDrawing = error instanceof ApiError && error.code === 'drawInProgress'
  return (
    <div role="alert" className={className}>
      <p className="font-body text-lg">{t(isNotFound ? 'zambePong.error.notFound' : isDrawing ? 'zambePong.error.drawing' : 'zambePong.error.load')}</p>
      {children}
    </div>
  )
}
